<template>
  <v-layout column>
    <v-flex xs12 md12>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="backToFriendList()">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 CSChatThai">ข้อมูลพื้นฐาน</v-toolbar-title>
      </v-toolbar>
    </v-flex>
  <div class="CSChatThai">
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; overflow-y: scroll; max-height: 90vh; color: rgb(74, 74, 74) !important;">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12>
              <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 md12 >
                        <div class="Setting">
                          <div>
                            <ul class="List_Register">
                              <li  class="List_item" style="justify-content: center;">
                                <div  class="List_item_body">
                                  <div class="SettingImg">
                                    <div class="SettingImgWrap">
                                      <div>
                                        <v-img src='/static/img/robot/developer1.png' class="alligator-turtle" style=" cursor: pointer; width: 80px; height: 80px;" v-if="filename == ''" @click="uppic"/>
                                        <img :src="filename" class="alligator-turtle" @click="uppic" v-else style=" cursor: pointer;width: 80px; height: 80px;">
                                        <div style="display: none;">
                                          <input class="CSChatThai" type="file" name="file1"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofilechat"/>
                                        </div>
                                        <label for="SettingImg" class="SettingImgBtn" @click="uppicmo">
                                          อัพโหลด
                                        </label>
                                      </div>
                                      <input data-v-0c521aa4="" type="file" name="file" id="uploadpicprofilechat" class="SettingImgInput" @change="previewImageprofiles">
                                    </div>
                                  </div>
                                  <p class="EditAreaNote">รองรับไฟล์ .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                                </div>

                              </li>
                            </ul>
                          </div>

                          <div  class="SettingBlock">
                            <p class="SettingTtl">ชื่อผู้พัฒนา</p>
                            <div v-if="!editname">
                              <div class="EditArea" >
                                <div class="EditAreaCont BreakWord">{{ name }}</div>
                                <v-btn flat small class="buttonedit" @click="editname = !editname">
                                  <span >แก้ไข</span>
                                </v-btn>
                              </div>
                            </div>
                            <div v-else>
                              <div class="EditAreaCont" >
                                <div  class="EditAreaContFlex">
                                  <input type="text" :placeholder="name" class="InputEdit" v-model="nameedit">
                                </div>
                              </div>
                              <div style="justify-content: center; display: flex;">
                                <v-btn flat small class="buttonedit" @click="updatename()">
                                  <span >อัพเดต</span>
                                </v-btn>
                                <v-btn flat small class="buttonedit" @click="editname = !editname">
                                  <span >ยกเลิก</span>
                                </v-btn>
                              </div>
                            </div>
                          </div>

                           <!-- <div  class="SettingBlock">
                            <p class="SettingTtl">คำอธิบายบริษัท</p>
                            <div v-if="!editdescription">
                              <div class="EditArea" >
                                <div class="EditAreaCont BreakWord" v-if="status != ''">{{ status }}</div>
                                <div class="EditAreaCont BreakWord" v-else>-</div>
                                <v-btn flat small class="buttonedit" @click="editdescription = !editdescription">
                                  <span >แก้ไข</span>
                                </v-btn>
                              </div>
                            </div>
                            <div v-else>
                              <div  class="EditAreaCont">
                                <div  class="EditAreaContFlex">
                                  <input type="text" :placeholder="status" class="InputEdit" v-model="statusedit">
                                </div>
                              </div>
                              <div style="display: flex; justify-content: center;">
                                <v-btn flat small class="buttonedit" @click="updatestatus()">
                                <span >อัพเดต</span>
                              </v-btn>
                              <v-btn flat small class="buttonedit" @click="editdescription = !editdescription">
                                <span >ยกเลิก</span>
                              </v-btn>
                              </div>
                            </div>
                          </div> -->

                           <div  class="SettingBlock">
                            <p class="SettingTtl">เบอร์โทรศัพท์</p>
                            <div>
                              <div class="EditArea">
                                <div class="EditAreaCont BreakWord">{{ phone }}</div>
                              </div>
                            </div>
                          </div>

                           <div  class="SettingBlock">
                            <p class="SettingTtl">ที่อยู่อีเมล</p>
                            <div>
                              <div class="EditArea">
                                <div class="EditAreaCont BreakWord">{{ email }}</div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </v-flex>


                      <!-- edit usrname and password -->
                  <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
                    <h3 class="header">ตั้งค่าชื่อผู้ใช้งานและรหัสผ่าน</h3>
                  </v-flex>
                  <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
                    <div class="Setting">
                    <!---->
                      <div class="SettingBlock">
                        <!-- <p class="SettingTtl">{{$t('Settings.editProfile.usernamepassword')}}</p> -->
                        <div>
                          <div class="EditArea" v-if="!editusername">
                            <v-layout column justify-center align-center>
                              <div class="EditAreaCont BreakWord" v-if="!loadingname">ชื่อผู้ใช้งานและรหัสผ่าน</div>
                              <div v-else class="EditAreaCont BreakWord">
                                <v-progress-linear :indeterminate="loadingname"></v-progress-linear>
                              </div>

                              <v-btn flat small class="buttonedit" @click="editusername = !editusername">
                                <span>แก้ไข</span>
                              </v-btn>
                            </v-layout>
                          </div>
                          <div class="EditArea" style="align-items: start !important;" v-else>
                            <div class="EditAreaCont">
                              <v-layout column justify-center alignCenter>
                                <v-text-field
                                  placeholder="ชื่อผู้ใช้"
                                  v-model="username"
                                  :rules="usernameRules"
                                  :error="chkUsernameDuplicate"
                                  :error-messages="msgUsernameDuplicate"
                                  @input="changeUsername"
                                  @keypress="isNumandaz($event)"
                                  autocapitalize="off"
                                  required
                                  solo
                                  ></v-text-field>

                                  <v-text-field
                                    placeholder="รหัสผ่าน"
                                    v-model="password"
                                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                                    :append-icon-cb="() => (e1 = !e1)"
                                    :type="e1 ? 'text' : 'password'"
                                    :rules="passwordRules"
                                    required
                                    solo
                                    @keypress="isnotthai($event)"
                                  ></v-text-field>

                                  <v-text-field
                                    placeholder="ยืนยันรหัสผ่าน"
                                    v-model="confirmpassword"
                                    :append-icon="e2 ? 'visibility' : 'visibility_off'"
                                    :append-icon-cb="() => (e2 = !e2)"
                                    :type="e2 ? 'text' : 'password'"
                                    :rules="repasswordRules"
                                    required
                                    solo
                                    @keypress="isnotthai($event)"
                                  ></v-text-field>
                                  <v-layout row wrap justify-center align-center>
                                    <v-btn flat small class="buttonedit" :loading="loadingname" :disabled="checkData()" @click="updateusername()">
                                      <span>อัปเดต</span>
                                    </v-btn>
                                    <v-btn flat small class="buttoncancel" @click="cancelusername()">
                                      <span>ยกเลิก</span>
                                    </v-btn>
                                  </v-layout>
                              </v-layout>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </v-flex>

<!-- mm -->
                  <v-flex sm12 md12 lg12 xl12 >
                    <h3  class="header">ข้อมูลการใช้ API</h3>
                  </v-flex>
                  <v-flex sm12 md12 lg12 xl12 >
                    <div class="Setting">
                      <div  class="SettingBlock">
                      <div class="EditArea" v-if="!tokenservice" style="justify-content: center;">
                        <v-btn flat small class="buttonedit" @click="openapi()" style="background-color: #1a76d2;">
                          <span style="color: white; font-size: 15px;">เปิดใช้งาน API</span>
                        </v-btn>
                      </div>
                      <div v-else>
                        <p class="SettingTtl">Token Service (Authorization)</p>
                        <div v-if="hideAuthen">
                          <div class="EditArea">
                            <div class="EditAreaCont BreakWord" v-if="tokenservice != ''">{{ tokenservice }}  <v-icon style="color:#0000008a; font-size: 13px !important; cursor: pointer; " v-clipboard:copy="tokenservice">file_copy</v-icon>
                            </div>
                          </div>
                          <div style="justify-content: center; display: flex;">
                            <v-btn flat small class="buttonedit" @click="hideAuthen = !hideAuthen">
                              <span >ซ่อน</span>
                            </v-btn>
                          </div>
                        </div>
                        <div v-else>
                          <div class="EditArea">
                            <div class="EditAreaCont BreakWord">ข้อความนี้ถูกซ่อน</div>
                            <v-btn flat small class="buttonedit" @click="hideAuthen = !hideAuthen">
                              <span >เปิด</span>
                            </v-btn>
                          </div>
                        </div>
                        <div style="margin-top: 5vh;">
                        <p class="SettingTtl">เอกสารการใช้งาน API</p>
                        <p>สามารถดูเอกสาร API เพิ่มเติมได้ที่ลิงค์นี้ <a href="https://chat-develop.one.th/docs" target="_blank">เอกสาร API</a></p>
                        </div>
                      </div>
                    </div>
                    </div>
                  </v-flex>
<!-- mm -->
                      <!-- <v-flex xs12 md12 >
                        <h3  class="header">ข้อมูลสำหรับ API</h3>
                      </v-flex>
                      <v-flex xs12 md12 >
                        <div class="Setting">
                          <div  class="SettingBlock">
                            <p class="SettingTtl">Token user</p>
                            <div>
                              <div class="EditArea">
                                <div class="EditAreaCont BreakWord">{{ token }}  <v-icon style="color:#0000008a; font-size: 13px !important; cursor: pointer; " v-clipboard:copy="token">file_copy</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>

                           <div  class="SettingBlock">
                            <p class="SettingTtl">Token Service (Authorization)</p>
                            <div>
                              <div class="EditArea" v-if="hideAuthen">
                                <div class="EditAreaCont BreakWord">{{ tokenservice }}  <v-icon style="color:#0000008a; font-size: 13px !important; cursor: pointer; " v-clipboard:copy="tokenservice">file_copy</v-icon>
                                </div>
                                 <v-btn flat small class="buttonedit" @click="hideAuthen = !hideAuthen">
                                <span >ซ่อน</span>
                              </v-btn>
                              </div>

                              <div class="EditArea" v-else>
                                <div class="EditAreaCont BreakWord">ข้อความนี้ถูกซ่อน</div>
                                <v-btn flat small class="buttonedit" @click="hideAuthen = !hideAuthen">
                                <span >เปิด</span>
                              </v-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-flex> -->

                      <v-flex xs12 md12 >
                        <h3  class="header">QR code สำหรับเพิ่มเพื่อน</h3>
                      </v-flex>
                      <v-flex xs12 md12 >
                        <div class="Setting">
                         <div class="SettingBlock">
                          <div class="SettingQr" style="justify-content: center;">
                            <!-- <p class="SettingTtl" >QR code</p>  -->
                            <p class="SettingQrImg" >
                              <qrcode :value="tokenuserQR" style="width: 150px;" id="downloadqr"></qrcode>
                            </p>

                          </div>

                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 md12>
                        <p class="SettingQrNote">คุณสามารถใช้ QR code นี้ส่งมอบให้บุคคลอื่น เพิ่มคุณเป็นเพื่อนได้
                      <a href="#" class="button" id="btn-download" :download="'user_' + name + '.png'" @click="loadqr()">Download</a>
                    </p>
                      </v-flex>
                  </v-layout>
                </v-container>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  data () {
    return {
      text: 'Lorem ipsum dolor sit am',
      development: '',
      phone: '',
      email: '',
      token: '',
      name: '',
      status: '',
      TypeSearch: '',
      search: '',
      NewArray: [], // เอาไว้รับค่าที่ socket ส่งมาเพื่อเก็บไว้
      ArrayList: [], // เอาไว้เก็บข้อมูลเพื่อทำการ push เก็บรอการส่งเข้า global variable
      tokenFriend: '',
      filename: '',
      webbackend: '',
      buttonRadio: [
        {label: 'Email', color: 'green', value: 'email'},
        {label: 'Botname', color: 'blue', value: 'botname'},
        {label: 'Phone', color: 'yellow', value: 'phone'}
      ],
      tokenedit: '',
      developmentedit: '',
      nameedit: '',
      statusedit: '',
      phoneedit: '',
      edit: false,
      editname: false,
      editdescription: false,
      returnresponse: '',
      tokenservice: '',
      tokenserviceedit: '',
      tokenuserQR: '',
      hideAuthen: false,
      active: null,
      menu1: 'select_Menu',
      menu2: 'nonselect_Menu',
      listbot: [],
      friendRead: 0,
      tokenserviceBearer: 'Bearer ',
      windowWidth: '',
      username: '',
      usernameedit: '',
      editusername: false,
      loadingname: false,
      password: '',
      confirmpassword: '',
      username_alerterror: '',
      password_alerterror: '',
      confirm_alerterror: '',
      chkUsernameDuplicate: false,
      msgUsernameDuplicate: [],
      e1: false,
      e2: false,
      usernameRules: [
        v => !!v || '' || 'กรุณากรอกชื่อผู้ใช้งาน',
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
        v => this.checkUsernameDuplicate() || '',
        v => this.regular_username_mobile()
      ],
      passwordRules: [
        v => !!v || 'กรุณากรอกรหัสผ่าน',
        v => this.regular_pass_mobile()
      ],
      repasswordRules: [
        v => !!v || 'กรุณากรอกรหัสผ่านซ้ำ',
        v => v === this.password || 'กรุณากรอกรหัสผ่านให้ตรงกัน',
        v => this.regular_repass_mobile()
      ],
      status_username: '',
    }
  },
  methods: {
    updateusername () {
      var body = {
        'tokenuser': this.token,
        'username': this.username,
        'password': this.password
      }
      // console.log(process.env.APImanage + '/set_username', body)
      this.loadingname = true
      this.$http.post(process.env.APImanage + '/set_username', body).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.loadingname = false
          this.$swal('', 'ตั้งค่าชื่อผู้ใช้งานและรหัสผ่านสำเร็จ', 'success')
          localStorage.setItem('status_username', 'true')
          this.status_username = 'true'
        } else {
          this.loadingname = false
          this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น กรุณาลองใหม่ในภายหลัง', 'error')
          localStorage.setItem('status_username', 'false')
          this.status_username = 'false'
          this.cancelusername()
        }
      }).catch(error => {
        console.log(error)
        this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น กรุณาลองใหม่ในภายหลัง', 'error')
      })
    },
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) { // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    checkData () {
      return (this.username === '' || this.password === '' || this.confirmpassword === '')
    },
    changeUsername () {
      if (this.chkChangeUsername) {
        this.chkChangeUsername = false
        this.msgUsernameDuplicate = []
        this.chkUsernameDuplicate = false
      }
    },
    regular_username_mobile () {
      this.username = this.username.replace(/[^a-z-0-9]/i, '')
      this.username = this.username.toLowerCase()
    },
    regular_pass_mobile () {
      this.password = this.password.replace(/^[ก-๛]+/i, '')
    },
    regular_repass_mobile () {
      this.confirmpassword = this.confirmpassword.replace(/^[ก-๛]+/i, '')
    },
    cancelusername () {
      this.editusername = !this.editusername
      // this.usernameedit = this.username
      this.username = ''
      this.password = ''
      this.confirmpassword = ''
    },
    checkUsernameDuplicate () {
      // console.log(this.username)
      if (this.username !== '') {
        this.$http.get(process.env.ONEID_API + '/check_username?username=' + this.username).then((response) => {
          // console.log(response.data)
          if (response.status === 200) {
            if (response.data.message === 'Success') {
              this.chkUsernameDuplicate = false
              this.msgUsernameDuplicate = []
            }
          }
        }, (error) => {
          // console.log(error.body)
          console.log(error.status)
          console.log(error.status === 400)
          if (error.status === 400) {
            console.log(error.body.errorMessage)
            if (error.body.errorMessage === 'username duplicate') {
              this.chkUsernameDuplicate = true
              this.msgUsernameDuplicate = ['ชื่อผู้ใช้งานซ้ำ']
              this.valid = false
            } else if (this.username === '') {
              this.msgUsernameDuplicate = ['กรุณากรอกชื่อผู้ใช้งาน']
            }
          }
        })
        return true
      }
    },
    // clickinputname () {
    //   ga('send','event','Edit Profile Engagement','Click Navbar','Input=Name')
    // },
    // clickinputstatus () {
    //   ga('send','event','Edit Profile Engagement','Click Navbar','Input=Status')
    // },
    loadqr () {
      var cnvs = document.getElementById('downloadqr')
      var button = document.getElementById('btn-download')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    },
    openapi () {
      this.$http.post(process.env.APImanage + '/openapibot', {tokenuser: this.token}).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.tokenservice = response.body['tokenservice']
          this.tokenservice = this.tokenserviceBearer + this.tokenservice
          localStorage.setItem('tokenservice', response.body['tokenservice'])
        }
      }, (response) => {})
    },
    backToFriendList () {
      this.$emit('data', true)
      this.$router.push('/mobile/develop/homepage')
      this.$store.dispatch('tokenRoom', 'noneselect')
      this.$store.dispatch('changeRightTool', 'Friend')
      this.$cookies.set('tokenRoom', 'noneselect')
      localStorage.setItem('room', 'noneselect')
      this.$store.dispatch('changeGroup', 'noneselect')
    },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    // routeProfile (data) {
    //   console.log(data)
    //   if (data === undefined) {
    //     this.$router.push('/mobile/develop/info')
    //     this.$store.dispatch('tokenRoom', 'noneselect')
    //     this.$store.dispatch('changeRightTool', 'Friend')
    //     this.$cookies.set('tokenRoom', 'noneselect')
    //     localStorage.setItem('room', 'noneselect')
    //     this.$store.dispatch('changeBot', 'noneselect')
    //   } else {
    //     this.$store.dispatch('tokenRoom', data.bot_id)
    //     this.$store.dispatch('changeBot', data)
    //     localStorage.setItem('room', data.bot_id)
    //     this.actionF = data.bot_id
    //     this.$store.dispatch('changeRightTool', 'Friend')
    //     this.$cookies.set('tokenRoom', data.bot_id)
    //     this.$router.push('/mobile/editbot/' + data.bot_id)
    //     this.$emit('data', true)
    //   }
    // },
    selectmenu (menu) {
      // console.log(menu)
      if (menu === 1) {
        this.active = 'tab-1'
        this.menu1 = 'select_Menu'
        this.menu2 = 'nonselect_Menu'
      } else if (menu === 2) {
        this.active = 'tab-2'
        this.menu1 = 'nonselect_Menu'
        this.menu2 = 'select_Menu'
      }
    },
    updatename () {
      this.editname = !this.editname
      this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
        // console.log(this.token)
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
    },
    updatestatus () {
      this.editdescription = !this.editdescription
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    uppic () {
      // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Photo')
      // $("#uploadpicprofilechat").click();
      document.getElementById('uploadpicprofilechat').click()
    },
    uppicmo () {
      // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Photo')
      // $("#uploadpicprofilechat").click();
      document.getElementById('uploadpicprofilechat').click()
    },
    editprofile () {
      this.edit = !this.edit
      this.nameedit = this.name
      this.statusedit = this.status
      this.phoneedit = this.phone
      this.emailedit = this.email
      this.tokenedit = this.token
      this.tokenserviceedit = this.tokenservice
    },
    changeprofile () {
      this.edit = !this.edit
      this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
        // console.log(this.token)
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    previewImageprofiles (data) {
      // console.log('previewImageprofile')
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      // console.log(this.selectFile)
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', localStorage.getItem('tokenuser'))
      this.$http.post(process.env.APImanage + '/setpictureprofileuser', uploadFile).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          // console.log('response.body')
          this.filename = response.body.filename
          this.returnresponse = response.body
          this.$store.dispatch('myProfile', response.body.filename)
          localStorage.setItem('profilepicture', response.body.filename)
        }
      }, (response) => {})
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth > 960) {
        this.$router.push('/develop/information_dev')
      }
    },
    myprofile () {
      // console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    }
  },
  created () {
    this.phone = localStorage.getItem('phone')
    this.email = localStorage.getItem('email')
    this.token = localStorage.getItem('tokenuser')
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.webbackend = process.env.API
    this.filename = localStorage.getItem('profilepicture')
    this.development = '-'
    if (localStorage.getItem('tokenservice') === '') {
      // console.log(this.tokenservice)
    } else {
      this.tokenservice = this.tokenserviceBearer + localStorage.getItem('tokenservice')
      // console.log(this.tokenservice)
    }
    if (localStorage.getItem('status_username') === 'false') {
      this.status_username = 'false'
    } else {
      this.status_username = 'true'
    }
    this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('tokenuser'))
    this.nameedit = this.name
    this.statusedit = this.status

    // this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
    //   this.listbot = response.body['listbot']
    //   this.routeProfile(this.listbot[this.findWithAttr(this.listbot, 'bot_id', localStorage.getItem('room'))])
    // })
  }
}
</script>
<style type="text/css">
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    /*margin-top: 5vh;*/
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 30px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/ProfileDevelopMobile.vue